import * as React from 'react';

import { cn } from '@/lib/utils';

import { Text } from '@/components/atoms/text';

export type AuthorItemProps = {
  image: React.ReactNode;
  name: string;
  title?: string;
  bio?: React.ReactNode;
  size?: 'small' | 'large';
};

export default function BlogAuthor({
  image,
  name,
  title,
  bio,
  size = 'large',
}: AuthorItemProps) {
  const sizesClasses = {
    small: {
      image: 'w-9 h-9',
      name: 'text-body-m',
      root: '',
      author: 'flex items-center justify-center',
      wrapper: 'flex items-center justify-center gap-2',
    },
    large: {
      image: 'h-full w-17 rounded-full pr-6',
      name: 'text-[18px] font-bold sm:text-subtitle-l',
      root: 'bg-neutral-N04 py-8 px-[20px] sm:p-9',
      author: 'grid py-[17px] justify-items-start',
      wrapper: 'flex pb-6',
    },
  }[size];

  return (
    <div className={cn('rounded-xl', sizesClasses.root)}>
      <div className={cn(sizesClasses.wrapper)}>
        <div className={cn('rounded-full', sizesClasses.image)}>{image}</div>
        <div className={cn(sizesClasses.author)}>
          <Text variant='subtitle-l' className={sizesClasses.name}>
            {name}
          </Text>
          {title && (
            <Text variant='body-s' className='text-body-s'>
              {title}
            </Text>
          )}
        </div>
      </div>
      {!!bio && <Text>{bio}</Text>}
    </div>
  );
}
